"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deepFreeze = deepFreeze;
function deepFreeze(value) {
    freezeRecursively(value, new WeakSet());
    return value;
}
function freezeRecursively(value, seen) {
    if (value === null || typeof value !== 'object' || seen.has(value)) {
        return;
    }
    seen.add(value);
    for (const nested of Object.values(value)) {
        freezeRecursively(nested, seen);
    }
    Object.freeze(value);
}
//# sourceMappingURL=deep-freeze.js.map